import React, { useContext } from 'react'
import styled from 'styled-components'
import BackOfficeRouting from './BackOfficeRouting'

const BackOffice = (): JSX.Element => {
  return (
    <Wrapper>
      <BackOfficeRouting />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .custom-editor {
    border-radius: 2px;
    border: 1px solid #f1f1f1;
  }
`

export default BackOffice
